module.exports = function(bootstrap) {
    bootstrap.directive('vbidView', function () {
        return {
            restrict: 'A',
            scope: false,
            replace: true,
            template: require('articles/providers/VBID.html'),
            controller: [{
            }]
        };
    });
};